import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { BvIconComponent } from "./icon.component";

/**
 * Centered empty state. Mirrors design-system.html .empty-state.
 *
 *   <bv-empty-state
 *     iconName="groups"
 *     title="No players yet"
 *     desc="Share the tournament link to invite players."
 *   >
 *     <button bv-button variant="primary">Invite</button>
 *   </bv-empty-state>
 */
@Component({
    selector: "bv-empty-state",
    templateUrl: "./empty-state.component.html",
    styleUrls: ["./empty-state.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "bv-empty-state" },
    imports: [BvIconComponent]
})
export class BvEmptyStateComponent {
  @Input() iconName?: string;
  @Input() title?: string;
  @Input() desc?: string;
}
